import {TextButton} from '../../index'

const EditTabButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick} variant={'contained'}>Edit Tab</TextButton>
    )
}

export default EditTabButton